export default function getTravelerDisplayName(info, profile) {
  const firstName = info.preferred_first_name || profile.first_name;
  const lastName = info.preferred_last_name || profile.last_name;
  const fullName = `${firstName} ${lastName}`.trim();

  return fullName || profile.email;
}
